// extracted by mini-css-extract-plugin
module.exports = {"restaurant_location_spinner_container":"RestaurantLocation_restaurant_location_spinner_container__1tk2q"};